__turbopack_context__.v({
  "imageBox": "SupportCard-module__tKlXnW__imageBox",
  "supportCardContainer": "SupportCard-module__tKlXnW__supportCardContainer",
});
